import React from "react";
import LoginHeader from "@/components/login/LoginHeader";
import LoginForm from "@/components/login/LoginForm";

/**
 * Full-screen login overlay. Visible whenever `user === null`.
 * Sits above the entire site; cannot be closed without a successful login.
 * Text is intentionally always in English regardless of the site locale.
 *
 * This shell is a thin composition layer — see LoginHeader (brand block)
 * and LoginForm (email/password + auth call) for the actual content.
 */
export default function LoginOverlay() {
  return (
    <div
      data-testid="login-overlay"
      className="fixed inset-0 z-[100] flex items-center justify-center"
      style={{ backgroundColor: "rgba(21,30,43,0.92)" }}
    >
      {/* Soft texture: a single still from the hero — atenuado */}
      <img
        src="https://images.unsplash.com/photo-1620677368158-32b1293fac36?auto=format&fit=crop&w=2200&q=80"
        alt=""
        aria-hidden
        className="absolute inset-0 w-full h-full object-cover opacity-30"
      />
      <div
        className="absolute inset-0"
        style={{ backgroundColor: "rgba(21,30,43,0.78)" }}
        aria-hidden
      />

      <div
        className="relative z-10 w-full max-w-[460px] mx-6 md:mx-0"
        style={{
          backgroundColor: "rgba(21,30,43,0.88)",
          backdropFilter: "blur(10px)",
          padding: "56px 48px",
          borderRadius: 1,
          border: "1px solid rgba(255,255,255,0.06)",
        }}
      >
        <LoginHeader />
        <LoginForm />

        <div className="mt-10 flex flex-col items-center">
          <a
            href="mailto:hello@viajadeverdad.com"
            className="text-ivory/45 hover:text-brass transition-colors"
            style={{ fontSize: 12, letterSpacing: "0.02em" }}
            data-testid="login-forgot"
          >
            Forgot password? Contact us at hello@viajadeverdad.com
          </a>
        </div>
      </div>
    </div>
  );
}
